import React from "react"

import * as S from "./nonprofits-home-hero.styles"

const NonprofitsHomeHero = ({ title, topTitle, backgroundImage, image }) => {
  return (
    <S.Section>
      <S.BackgroundImage img={backgroundImage}>
        <S.Wrapper maxWidth="lg">
          <S.TopTitle>{topTitle}</S.TopTitle>
          <S.Title>{title}</S.Title>
        </S.Wrapper>
        <S.Image img={image} />
      </S.BackgroundImage>
    </S.Section>
  )
}

export default NonprofitsHomeHero
